// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.email-template-customer-portal-tab-container .spinner-layer[data-v-0cfbaa98] {\n  height: 200px;\n}\n.email-template-customer-portal-tab-container[data-v-0cfbaa98] .e-toolbar-right .e-toolbar-item:last-child {\n  border-radius: 0 50% 50% 0 !important;\n  padding: 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
